"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareButton = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../../dsl/front");
/**
 * @author Sebastian Dziechciarz
 */
let ShareButton = class ShareButton extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.actionIcon = '';
    }
    created() {
        this.actionIcon = this.icon;
    }
    /**
     * Handles `@click` event on the `<button>`.
     */
    onClick() {
        this.callback();
        if (this.clickedIcon) {
            this.actionIcon = this.clickedIcon;
            setTimeout(() => {
                this.actionIcon = this.icon;
            }, 2000);
        }
    }
};
__decorate([
    vue_property_decorator_1.Prop({
        type: Function,
        required: true
    }),
    __metadata("design:type", Function)
], ShareButton.prototype, "callback", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: false,
        default: ''
    }),
    __metadata("design:type", String)
], ShareButton.prototype, "icon", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: false,
        default: ''
    }),
    __metadata("design:type", Object)
], ShareButton.prototype, "clickedIcon", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: true
    }),
    __metadata("design:type", String)
], ShareButton.prototype, "label", void 0);
ShareButton = __decorate([
    vue_property_decorator_1.Component({
        name: 'ShareButton',
        components: {
            BootstrapButton: front_1.BootstrapButton,
            BootstrapIcon: front_1.BootstrapIcon
        },
        template: `
    <BootstrapButton class="share-button btn-link-dark px-0" @click="onClick">
    <BootstrapIcon :name="actionIcon" size="small" class="share-button__icon"
                   :class="{'text-success':(actionIcon==='checkmark')}"/>
    <span class="text-ui-x-small text-uppercase mb-0">
        {{ label }}
      </span>
    </BootstrapButton>
  `
    })
], ShareButton);
exports.ShareButton = ShareButton;
exports.default = ShareButton;
//# sourceMappingURL=ShareButton.js.map